<template>
    <v-col v-if="!navbarra && !IDcuestionario" cols="12">
        <v-card class="mx-4">
            <!-- Button for 'mirar' option -->
            <v-btn block color="primary" v-if="selectedOption === 'editar'" @click="openDialog('crear')">
                {{ t('Crear') }} {{ t('cuestionario') }}
            </v-btn>
        </v-card>
    </v-col>
    <template v-if="IDcuestionario">
        <v-col v-if="!navbarra" cols="12">
            <v-card class="mx-4">
                <!-- Button for 'mirar' option -->
                <v-btn block color="primary" v-if="selectedOption === 'mirar' && selectedOptionVista !== 'docente'"
                    @click="accederCuestionario">
                    {{ tipo_reto === 'encuesta'
                        ? t('Responde_a_la_encuesta')
                        : t('Ponte_a_prueba')
                    }}
                </v-btn>
                <v-btn block color="primary" v-if="selectedOption === 'mirar' && selectedOptionVista === 'docente'"
                    @click="accederCuestionario">
                    {{ t('Evalua_un_alumno') }}
                </v-btn>

                <v-btn class="mt-4" color="primary"
                    v-if="selectedOption === 'mirarooooooooo' && selectedOptionVista === 'docente'"
                    prepend-icon="mdi-qrcode" @click="launchQuiz">
                    {{ t('Quizz_en_Directo') }}
                </v-btn>
                <!-- Button for 'editar' option -->
                <v-btn block color="primary" v-if="selectedOption === 'editar'" @click="openPreguntasDialog">
                    {{ t('Editar') }} {{ t('preguntas') }}
                </v-btn>
            </v-card>
        </v-col>
        <template v-if="navbarra">
            <v-btn v-if="selectedOption === 'mirar'" :icon="mdiIcon" :color="starColor" variant="text"
                @click="accederCuestionario"></v-btn>
            <v-btn v-if="selectedOption === 'editar'" icon="mdi-star" color="primary" variant="text"
                @click="openPreguntasDialog"></v-btn>
        </template>
    </template>

    <v-dialog v-model="overlay" class="align-center justify-center" persistent fullscreen scrollable>
        <v-skeleton-loader v-if="loading" type="card"></v-skeleton-loader>
        <v-card v-if="!loading">
            <v-toolbar flat>
                <v-toolbar-title>{{ cuestionario.titulo }}</v-toolbar-title>
                <v-chip>
                    {{ t('Intentos_restantes') }}
                    <v-avatar end>
                        <v-progress-circular :model-value="progresoIntentos" color="primary">
                            {{ cuestionario.num_intentos === 0 ? '∞' : intentosRestantes }}
                        </v-progress-circular>
                    </v-avatar>
                </v-chip>
                <v-btn icon @click="cerrarOverlay">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title v-if="alumnoSeleccionado.nombre && selectedOptionVista === 'docente'">{{
                t('Evaluando_a')
            }} {{ alumnoSeleccionado.nombre }} {{ alumnoSeleccionado.apellidos }}</v-card-title>
            <v-progress-linear color="primary" :model-value="progress" :height="12"></v-progress-linear>
            <HelperCarregant v-if="loading" :missatge="t('Cargando') + ' ' + t('datos')" />
            <v-card-text v-if="!loading" style="overflow-y: auto;" class="pa-0 pa-md-4">
                <template v-if="!feedback">
                    <v-window disabled v-model="onboarding">
                        <!-- Si no hay alumno seleccionado y estamos en modo docente, mostramos la lista de alumnos -->
                        <template v-if="!alumnoSeleccionado.nombre && selectedOptionVista === 'docente'">
                            <v-card class="mx-4">
                                <v-toolbar flat>
                                    <v-toolbar-title>{{ t('Alumnos') }}</v-toolbar-title>
                                </v-toolbar>
                                <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca"
                                    prepend-inner-icon="mdi-magnify" single-line variant="outlined"
                                    hide-details></v-text-field>
                                <v-data-table-virtual :headers="headers" :items="tablaAlumnosNotas" :search="search"
                                    :loading="loading2">
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-icon class="mr-4" @click="seleccionarAlumno(item)">mdi-account-check</v-icon>
                                        <v-icon @click="editarFecha(item)">mdi-history</v-icon>
                                    </template>
                                    <template v-slot:loading>
                                        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                                    </template>
                                </v-data-table-virtual>
                            </v-card>
                        </template>
                        <template v-else>
                            <!-- Mostrar secuencias solo en modo docente -->
                            <template
                                v-if="selectedOptionVista === 'docente' && respuestas.secuencias && respuestas.secuencias.length > 0 && !fechaDialog">
                                <div v-for="secuencia in respuestas.secuencias" :key="secuencia.id">
                                    <v-card class="mb-4">
                                        <v-card-title>{{ secuencia.plano.nombre }} ({{ secuencia.posicion
                                            }})</v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model="secuencia.tiempo_inicial"
                                                        label="Tiempo Inicial (mm:ss)" type="text"
                                                        @input="formatTime($event, 'tiempo_inicial', secuencia)">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model="secuencia.tiempo_final"
                                                        label="Tiempo Final (mm:ss)" type="text"
                                                        @input="formatTime($event, 'tiempo_final', secuencia)">
                                                    </v-text-field>
                                                </v-col>
                                                <v-list class="py-0" v-for="criterio in secuencia.plano.criterios"
                                                    :key="criterio.id">
                                                    <v-checkbox v-model="criterio.seleccionado"
                                                        :label="criterio.descripcion">
                                                    </v-checkbox>
                                                </v-list>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                                <v-btn @click="submitEvaluation">{{ t('Guardar') }}</v-btn>
                            </template>
                            <!-- Mostrar preguntas en modo alumno o si no hay secuencias -->
                            <template v-else>
                                <template v-if="!fechaDialog">
                                    <v-window-item v-for="pregunta in cuestionario.preguntas" :key="pregunta.id">
                                        <div v-if="pregunta.tipo === 'ordenar'">
                                            <PreguntaOrdenar :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'relacionar'">
                                            <PreguntaRelacionar :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'relacionar_cols'">
                                            <PreguntaRelacionarCols :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'multiple_choice'">
                                            <PreguntaMultipleChoice :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'single_choice'">
                                            <PreguntaSingleChoice :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'gradacion'">
                                            <PreguntaGradacion :pregunta="pregunta"
                                                :selectedOptionVista="selectedOptionVista"
                                                :alumnoID="alumnoSeleccionado.usuario_id"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'texto'">
                                            <PreguntaText :pregunta="pregunta" @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'contenido'">
                                            <PreguntaContenido :pregunta="pregunta"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                        <div v-if="pregunta.tipo === 'hotspot'">
                                            <PreguntaHotspot :pregunta="pregunta"
                                                :selectedOptionVista="selectedOptionVista"
                                                :alumnoID="alumnoSeleccionado.usuario_id"
                                                @respuesta-enviada="handleRespuesta" />
                                        </div>
                                    </v-window-item>
                                </template>
                            </template>
                        </template>
                    </v-window>
                </template>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- Diálogo para feedback -->
    <v-dialog v-model="feedback2">
        <v-card class="d-flex flex-column mx-auto py-8" elevation="10" height="450" width="400">
            <div class="d-flex justify-center mt-auto text-h5 ">
                {{ ratingDetails.message }}
            </div>
            <div class="d-flex align-center flex-column my-auto">
                <div class="text-h2 mt-5">
                    {{ nota2 }}
                    <span class="text-h6 ml-n3">/10</span>
                </div>
                <v-rating size="72" v-model="rating" length="3" :active-color="ratingDetails.color" color="grey"
                    readonly>
                </v-rating>
            </div>
            <v-card-text v-if="nota_previa !== 0" class="text-subtitle-1 text-center" cols="12">
                {{ t('Record_personal') }}: {{ nota_previa }}
            </v-card-text>
            <div class="px-3 d-flex align-center flex-column">
                <v-btn @click="acceptaFeedback" color="primary">
                    {{ t('Cerrar') }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
    <!-- Diálogo para crear un nuevo cuestionario -->
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>
                    {{ dialogType === 'crear' ? t('Crear') : t('Editar') }} {{ t('cuestionario') }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" @click="dialogType === 'crear' ? crearCuestionario() : editarCuestionario()"
                    prepend-icon="mdi-content-save">
                    {{ dialogType === 'crear' ? t('Crear') : t('Guardar') }}
                </v-btn>
                <!-- Exportar -->
                <v-btn color="primary" prepend-icon="mdi-download" v-if="IDcuestionario && selectedOption === 'editar'"
                    @click="exportarCuestionario(false)">
                    {{ t('Exportar') }} JSON
                </v-btn>

                <!-- Exportar con imágenes base64 -->
                <v-btn class="ml-2" color="secondary" prepend-icon="mdi-image"
                    v-if="IDcuestionario && selectedOption === 'editar'" @click="exportarCuestionario(true)">
                    {{ t('Exportar') }} + img
                </v-btn>

                <!-- Importar -->
                <v-btn color="primary" prepend-icon="mdi-upload" v-if="!IDcuestionario && selectedOption === 'editar'"
                    @click="$refs.fileInput.click()">
                    {{ t('Importar') }} {{ t('cuestionario') }}
                </v-btn>
                <input ref="fileInput" type="file" accept="application/json" style="display:none"
                    @change="importarCuestionario" />

                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <HelperCarregant v-if="loading" :missatge="t('Creando') + ' ' + t('cuestionario')" />
                <template v-if="!loading">
                    <v-text-field v-model="nuevoCuestionario.titulo" :label="t('Título')" required></v-text-field>
                    <v-text-field type="number" v-model="nuevoCuestionario.num_preguntas"
                        :label="t('Número_de') + ' ' + t('preguntas')" required></v-text-field>
                    <v-text-field type="number" v-model="nuevoCuestionario.num_intentos"
                        :label="t('Número_de') + ' ' + t('intentos')" required></v-text-field>
                    Intentos por defecto 0 (infinitos)
                    <v-expansion-panels class="mt-4">
                        <v-expansion-panel :title="t('Opciones_adicionales')">
                            <v-expansion-panel-text>
                                <v-select v-model="nuevoCuestionario.tipo_reto"
                                    :items="['normal', 'encuesta', 'ordenado']"
                                    :label="t('Tipo_de') + ' ' + t('cuestionario')" required></v-select>
                                <v-text-field v-model="nuevoCuestionario.puntaje_practico_diez" label="Puntaje de 10">
                                    <template v-slot:append>
                                        <HelpComponent helpType="puntaje_practico_diez"></HelpComponent>
                                    </template></v-text-field>
                                <v-btn v-if="dialogType === 'editar'" color="red" text prepend-icon="mdi-delete"
                                    @click="confirmarEliminacion">
                                    {{ t('Eliminar') }}
                                </v-btn>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </template>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- Diálogo para el CRUD de preguntas -->
    <v-dialog v-model="preguntasDialog" persistent :fullscreen="display.smAndDown.value">
        <AdminPreguntes :cuestionario="cuestionario" :loading="loading" @cerrar-preguntas="closePreguntasDialog"
            @detalles-cuestionario="openDialog('editar')" @actualizar-preguntas="fetchCuestionario" />
    </v-dialog>
    <!-- Diálogo para editar fecha -->
    <v-dialog v-model="fechaDialog" :fullscreen="display.smAndDown.value">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Puntaje') }}</v-toolbar-title>
                <v-btn icon @click="closeFechaDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-text-field disabled :label="t('Nota')" v-model="datosPuntaje.nota"></v-text-field>
                <v-text-field disabled :label="t('Puntaje')" v-model="datosPuntaje.puntaje"></v-text-field>
                <v-date-picker v-model="datosPuntaje.fecha_oficial"></v-date-picker>
                <v-btn @click="guardarFecha" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }} {{ t('fecha') }} en relación a este cuestionario
                </v-btn>
                <v-btn @click="actualizarPuntajes" prepend-icon="mdi-content-save">
                    {{ t('Actualizar') }} {{ t('puntajes') }}
                </v-btn>
                Actualizar puntajes permite recalcular la puntuación teórica del alumno y modificar la fecha en la que
                la
                actividad se completó.
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios';
import { useDisplay } from 'vuetify';
import PreguntaOrdenar from './PreguntaOrdenar.vue';
import PreguntaRelacionar from './PreguntaRelacionar.vue';
import PreguntaRelacionarCols from './PreguntaRelacionarCols.vue';
import PreguntaMultipleChoice from './PreguntaMultipleChoice.vue';
import PreguntaSingleChoice from './PreguntaSingleChoice.vue';
import PreguntaGradacion from './PreguntaGradacion.vue';
import PreguntaText from './PreguntaText.vue';
import PreguntaContenido from './PreguntaContenido.vue';
import PreguntaHotspot from './PreguntaHotspot.vue';
import AdminPreguntes from './AdminPreguntes.vue';
import HelperCarregant from './HelperCarregant.vue';
import HelpComponent from './HelpComponent.vue'
import { useUiStore } from '@/stores/ui';
import { useCursosStore } from '@/stores/cursos';

const { t } = useI18n();
const router = useRouter();
const display = useDisplay();

const props = defineProps({
    IDcuestionario: String,
    IDleccion: String,
    cursoId: String,
    selectedOption: String,
    selectedOptionVista: String,
    navbarra: Boolean,
    tipo_reto: String,
    nota_usuario: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['respuesta-enviada', 'nuevo-cuestionario', 'eliminar-cuestionario']);

const uiStore = useUiStore();     // snackbar, vista seleccionada…
const cursosStore = useCursosStore(); // cuestionario, tablas, loading…
const loading = computed(() => cursosStore.loadingCuestionario);
const cuestionario = computed(() => cursosStore.cuestionario);
const tablaAlumnosNotas = computed(() => cursosStore.tablaTeoria);
const overlay = ref(false);
const onboarding = ref(0);
const loading2 = ref(false);
const respuestas = reactive({ preguntas: [], secuencias: [] });
const resultat = ref([]);
const feedback = ref(false);
const feedback2 = ref(false);
const rating = ref(0);
const dialog = ref(false);
const fechaDialog = ref(false);
const preguntasDialog = ref(false);
const dialogType = ref('');
const nota2 = ref(0);
const nota_previa = ref(0);
const nuevoCuestionario = reactive({
    leccion: null,
    titulo: '',
    tipo_reto: 'normal',
    num_preguntas: 10,
    num_intentos: 0,
    tiempo_contrareloj: 60,
    bonus: 5,
    penalizacion: 10,
    puntaje_practico_diez: 10,
});
const snackbarText = ref('');
const headers = ref([
    { title: t('Nombre'), key: 'nombre' },
    { title: t('Apellidos'), key: 'apellidos' },
    { title: t('Acciones'), key: 'action', sortable: false },
]);

const alumnos_total = ref([]);
const search = ref('');
const alumnoSeleccionado = ref({ nombre: '', apellidos: '', usuario_id: null });
const datosPuntaje = ref({ nota: null, puntaje: null, fecha_oficial: null });

const progress = computed(() => {
    // If there is no cuestionario or no preguntas, fallback 0
    const total = cuestionario.value?.preguntas?.length || 0;
    if (total === 0) return 0;
    // E.g. how many steps completed so far
    return ((onboarding.value + 1) / total) * 100;
});

// Instead of preguntasIDs as a ref you assign manually, do:
const preguntasIDs = computed(() => {
    // Handle the case where 'cuestionario' or 'cuestionario.preguntas' might not exist yet
    if (!cuestionario.value || !cuestionario.value.preguntas) return [];
    return cuestionario.value.preguntas.map((p) => p.id);
});

const intentosRestantes = computed(() => {
    const maxIntentos = cuestionario.value?.num_intentos || 0;
    const realizados = cuestionario.value?.intentos_realizados || 0;

    // 0 = intents infinits
    if (maxIntentos === 0) {
        return null;
    }

    return Math.max(maxIntentos - realizados, 0);
});

const progresoIntentos = computed(() => {
    const maxIntentos = cuestionario.value?.num_intentos || 0;

    // Si són infinits, deixem el cercle complet
    if (maxIntentos === 0) {
        return 100;
    }

    return (intentosRestantes.value / maxIntentos) * 100;
});

function cleanAlumno() {
    alumnoSeleccionado.value.nombre = '';
    alumnoSeleccionado.value.usuario_id = null;
    alumnoSeleccionado.value.apellidos = '';
}

function closeFechaDialog() {
    fechaDialog.value = false;
    cleanAlumno()
}

function seleccionarAlumno(item) {
    alumnoSeleccionado.value = { ...item };
    console.log('seleccionarAlumno:', alumnoSeleccionado.value)
    console.log('seleccionarAlumno.usuario_id:', alumnoSeleccionado.value.usuario_id)
    // Llamar a la función para obtener las respuestas del docente
    obtenerRespuestasDocente(alumnoSeleccionado.value.usuario_id);

}

function editarFecha(item) {
    alumnoSeleccionado.value = { ...item };
    obtenerDatosPuntaje(alumnoSeleccionado.value.usuario_id);
}

const obtenerDatosPuntaje = async (alumnoId) => {
    try {
        const response = await axios.get(`datos_puntaje/${alumnoId}/${props.IDcuestionario}/`);
        console.log('response:', response.data)
        datosPuntaje.value = response.data
        fechaDialog.value = true;
    } catch (error) {
        if (error.response && error.response.data) {
            snackbarText.value = error.response.data.detail;
        } else {
            snackbarText.value = error;
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: '' });
        cerrarOverlay()
        accederCuestionario()
    }
}

const guardarFecha = async () => {
    if (!datosPuntaje.value.fecha_oficial) {
        uiStore.triggerSnackbar({
            message: 'Debes seleccionar una fecha válida.',
            color: 'warning'
        })
        return
    }
    try {
        const payload = { fecha_oficial: datosPuntaje.value.fecha_oficial }
        const url = `puntaje/${alumnoSeleccionado.value.usuario_id}/${props.IDcuestionario}/fecha_oficial/`
        await axios.patch(url, payload)

        // Éxito: cierra diálogo, muestra snackbar y opcionalmente refresca datos
        fechaDialog.value = false
        uiStore.triggerSnackbar({
            message: 'Fecha oficial actualizada correctamente.',
            color: 'success'
        })
        cleanAlumno();
    } catch (error) {
        snackbarText.value = error.response?.data?.message || error.message
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' })
        cleanAlumno();
    }
}

const actualizarPuntajes = async () => {
    try {
        const payload = { fecha_oficial: datosPuntaje.value.fecha_oficial }
        const url = `puntajecurso/${alumnoSeleccionado.value.usuario_id}/${props.cursoId}/fecha_oficial/`
        await axios.patch(url, payload)

        // Éxito: cierra diálogo, muestra snackbar y opcionalmente refresca datos
        fechaDialog.value = false
        uiStore.triggerSnackbar({
            message: 'Fecha oficial actualizada correctamente.',
            color: 'success'
        })
        cleanAlumno();
    } catch (error) {
        snackbarText.value = error.response?.data?.message || error.message
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' })
        cleanAlumno();
    }
}

// Función que hace la solicitud para obtener las respuestas del docente
const obtenerRespuestasDocente = async (alumnoId) => {
    console.log('alumnoId:', alumnoId)
    try {
        const response = await axios.get(`respuestas_docente/${alumnoId}/${props.IDcuestionario}/`);
        console.log('response:', response.data)
        formularQuestionariDocent(response.data);
    } catch (error) {
        if (error.response && error.response.data) {
            snackbarText.value = error.response.data.message;
        } else {
            snackbarText.value = error;
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    }
};

// Modificación de formularQuestionariDocent para utilizar las respuestas del docente
const formularQuestionariDocent = (datosRespuestas) => {
    Object.assign(respuestas, cuestionario.value);
    console.log('respuestas:', respuestas.secuencias)
    console.log('cuestionario:', cuestionario.value)
    console.log('datosRespuestas:', datosRespuestas)

    if (respuestas.secuencias && datosRespuestas) {
        respuestas.secuencias.forEach((secuencia) => {
            const secuenciaGuardada = datosRespuestas.find(dr => dr.secuencia_ejercicio.id === secuencia.id);
            console.log('secuencia guardada:', secuenciaGuardada);

            if (secuenciaGuardada) {

                // Convert and format tiempo_inicial
                let tiempo_inicial = parseInt(secuenciaGuardada.tiempo_inicial, 10) || 0;
                let minutos = Math.floor(tiempo_inicial / 60).toString().padStart(2, '0');
                let segundos = (tiempo_inicial % 60).toString().padStart(2, '0');
                secuencia.tiempo_inicial = `${minutos}:${segundos}`;

                // Convert and format tiempo_final
                let tiempo_final = parseInt(secuenciaGuardada.tiempo_final, 10) || 0;
                let minutosFinal = Math.floor(tiempo_final / 60).toString().padStart(2, '0');
                let segundosFinal = (tiempo_final % 60).toString().padStart(2, '0');
                secuencia.tiempo_final = `${minutosFinal}:${segundosFinal}`;

                // Create a set of IDs of criterios cumplidos
                const criteriosCumplidosIds = new Set(secuenciaGuardada.criterios_cumplidos.map(criterio => criterio.id));

                // Iterate over criterios and assign seleccionado based on whether the criterio.id is in criteriosCumplidosIds
                secuencia.plano.criterios.forEach((criterio) => {
                    criterio.seleccionado = criteriosCumplidosIds.has(criterio.id);
                });
            }
        });
    }
};

const formatTime = (event, field, secuencia) => {
    let value = event.target.value;

    // Remove all non-digit characters
    value = value.replace(/[^0-9]/g, '');

    // Ensure value is not longer than 4 characters (mmss)
    if (value.length > 4) {
        value = value.substr(0, 4);
    }

    // Add colon after two digits
    if (value.length > 2) {
        value = value.substr(0, 2) + ':' + value.substr(2);
    }

    // Update the corresponding field in secuencia
    secuencia[field] = value;
};

const isValidTimeFormat = (time) => {
    // Si el campo está vacío, es válido
    if (!time) {
        return true;
    }
    const timePattern = /^\d{2}:\d{2}$/;
    if (!timePattern.test(time)) {
        return false;
    }

    // Split the time into minutes and seconds
    const [minutes, seconds] = time.split(':').map(Number);

    // Check if minutes and seconds are within the range
    return minutes <= 59 && seconds <= 59;
};

const submitEvaluation = async () => {
    snackbarText.value = '';

    // Validate time format for each secuencia
    for (let secuencia of respuestas.secuencias) {
        if (!isValidTimeFormat(secuencia.tiempo_inicial) || !isValidTimeFormat(secuencia.tiempo_final)) {
            snackbarText.value = `Error en ${secuencia.plano.nombre} (${secuencia.posicion}): Algún campo de tiempo tiene un formato incorrecto.`;
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
            return; // Stop the submission process and show the error
        }
    }

    // Construct the data object to send
    const datosParaEnviar = {
        respuestas_docente: respuestas,
        alumno: alumnoSeleccionado.value.usuario_id,
        curso: props.cursoId,
    };
    try {
        const response = await axios.post(`enviar_respuestas_docente/`, datosParaEnviar);

        // Handle the server response
        if (response.data.success) {
            snackbarText.value = t('Formulario') + ' ' + t('actualizado_con_éxito');
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        }
    } catch (error) {
        snackbarText.value = error.response ? error.response.data.message : error.message;
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    }
};
const ratingDetails = computed(() => {
    let details = {
        color: 'grey', // Default color
        message: t('Inténtalo_de_nuevo'),
    };

    switch (rating.value) {
        case 3:
            details.color = 'amber-accent-2';
            details.message = t('Excelente');
            break;
        case 2:
            details.color = 'blue-grey-lighten-2';
            details.message = t('Buen_esfuerzo');
            break;
        case 1:
            details.color = 'deep-orange-lighten-2';
            details.message = t('Aceptable_aunque_puedes_mejorar');
            break;
        case 0:
            details.color = 'red';
            details.message = t('Inténtalo_de_nuevo');
            break;
    }
    return details;
});

const nota = computed(() => {
    if (!props.nota_usuario || props.nota_usuario.nota === null) {
        return null;
    }
    const valor = Number(props.nota_usuario.nota);
    const valorLimitado = Math.min(10, Math.max(0, valor));
    return Number(valorLimitado.toFixed(1));
});


const starColor = computed(() => {
    if (nota.value === null) {
        return 'grey';
    }
    if (nota.value >= 9) {
        return 'amber-accent-2';
    } else if (nota.value >= 7) {
        return 'blue-grey-lighten-2';
    } else if (nota.value >= 5) {
        return 'deep-orange-lighten-2';
    } else {
        return 'red';
    }
});

const mdiIcon = computed(() => {
    if (!props.tipo_reto || props.tipo_reto === null) {
        return 'mdi-progress-question'; // Default 
    } else if (props.tipo_reto == "encuesta") {
        if (!props.nota_usuario || props.nota_usuario.nota === null) {
            return 'mdi-file-question-outline'; // Default icon if no grade
        } else {
            return 'mdi-file-check-outline';
        }
    } else {
        if (!props.nota_usuario || props.nota_usuario.nota === null) {
            return 'mdi-progress-question'; // Default icon if no grade
        } else {
            const nota = Math.round(props.nota_usuario.nota);
            if (nota >= 10) {
                return 'mdi-star-shooting';
            } else if (nota < 5) {
                return 'mdi-close-circle-outline';
            } else {
                return 'mdi-star';
            }
        }
    }
});

const fetchAlumnes = async () => {
    loading2.value = true;
    try {
        const response = await axios.get(`curso/${props.cursoId}/alumnos_total/`);
        alumnos_total.value = response.data;
    } catch (error) {
        if (error.response && error.response.status === 403) {
            console.error("Error obtaining students:", error);
        } else {
            // Handle other types of errors
            alert("An error occurred while fetching students.");
        }
    } finally {
        loading2.value = false;
    }
};

function openPreguntasDialog() {
    fetchCuestionario();
    preguntasDialog.value = true;
}

function closePreguntasDialog() {
    preguntasDialog.value = false;
}

function acceptaFeedback() {
    emit('respuesta-enviada');
    feedback2.value = false;
    cerrarOverlay();
}

async function fetchCuestionario() {
    if (!props.IDcuestionario) return;

    feedback.value = false;
    await cursosStore.fetchCuestionario(props.IDcuestionario);
}

async function evaluarCuestionario() {
    feedback.value = true;
    const datosParaEnviar = {
        IDcuestionario: props.IDcuestionario,
        preguntasIDs: preguntasIDs.value,
    };
    try {
        const response = await axios.post(`evaluar/`, datosParaEnviar);
        resultat.value = response.data;
        nota_previa.value = resultat.value.nota_previa;
        nota2.value = Number(resultat.value.nota.toFixed(1));
        if (nota2.value >= 9) {
            rating.value = 3;
        } else if (nota2.value >= 7) {
            rating.value = 2;
        } else if (nota2.value >= 5) {
            rating.value = 1;
        } else {
            rating.value = 0;
        }
        feedback2.value = true;
        cerrarOverlay();
    } catch (error) {
        if (error.response && error.response.status === 403) {
            // If error is 403 Forbidden, user has no access
        }
        uiStore.triggerSnackbar({ message: error, color: 'error' });
        cerrarOverlay();
    }
}

function handleRespuesta() {
    next();
}

function next() {
    if (onboarding.value + 1 >= cuestionario.value.preguntas.length) {
        // Close the overlay and reset onboarding to the start (or handle it differently if needed)
        evaluarCuestionario();
    } else {
        onboarding.value = onboarding.value + 1;
        progress.value = ((onboarding.value + 1) / cuestionario.value.preguntas.length) * 100;
    }
}

async function accederCuestionario() {
    await fetchCuestionario();

    const maxIntentos = cuestionario.value.num_intentos;
    const intentosRealizados = cuestionario.value.intentos_realizados || 0;

    // 0 significa intents il·limitats
    if (maxIntentos !== 0) {

        // Ja ha consumit tots els intents
        if (intentosRealizados >= maxIntentos) {
            uiStore.triggerSnackbar({
                message: t('Has_alcanzado_el_numero_maximo_de_intentos'),
                color: 'error',
            });

            return;
        }

        // Només queda un intent
        if (maxIntentos - intentosRealizados === 1) {
            uiStore.triggerSnackbar({
                message: t('Atencion_este_es_tu_ultimo_intento'),
                color: 'warning',
            });
        }
    }

    feedback.value = false;
    onboarding.value = 0;
    overlay.value = true;
}

function cerrarOverlay() {
    overlay.value = false;
    onboarding.value = 0;
    cleanAlumno();
}

async function editarCuestionario() {
    nuevoCuestionario.leccion = props.IDleccion;
    try {
        await axios.put(`cuestionarios/${props.IDcuestionario}`, nuevoCuestionario);
        snackbarText.value = t('Cuestionario') + ' ' + t('actualizado_con_éxito');
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        fetchCuestionario();
        dialog.value = false; // Close dialog after editing
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            // Extract error messages from the response body
            const errors = error.response.data;
            let errorMessage = '';
            // Iterate over each key in the errors object to build the message
            Object.keys(errors).forEach((key) => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`; // Join to convert possible arrays into strings
            });
            snackbarText.value = errorMessage;
        } else {
            // If the error response is not in the expected format
            snackbarText.value = error;
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    }
}

function openDialog(type) {
    dialogType.value = type;
    dialog.value = true;
    if (type === 'editar' && cuestionario) {
        nuevoCuestionario.titulo = cuestionario.value.titulo;
        nuevoCuestionario.tipo_reto = cuestionario.value.tipo_reto;
        nuevoCuestionario.num_preguntas = cuestionario.value.num_preguntas;
        nuevoCuestionario.num_intentos = cuestionario.value.num_intentos;
        nuevoCuestionario.tiempo_contrareloj =
            cuestionario.value.tiempo_contrareloj || nuevoCuestionario.tiempo_contrareloj;
        nuevoCuestionario.bonus = cuestionario.value.bonus || nuevoCuestionario.bonus;
        nuevoCuestionario.penalizacion = cuestionario.value.penalizacion || nuevoCuestionario.penalizacion;
        nuevoCuestionario.puntaje_practico_diez = cuestionario.value.puntaje_practico_diez;
    } else {
        nuevoCuestionario.leccion = props.IDleccion;
        nuevoCuestionario.titulo = '';
        nuevoCuestionario.tipo_reto = 'normal';
        nuevoCuestionario.num_preguntas = 10;
        nuevoCuestionario.num_intentos = 0;
        nuevoCuestionario.tiempo_contrareloj = 90;
        nuevoCuestionario.bonus = 5;
        nuevoCuestionario.penalizacion = 10;
        nuevoCuestionario.puntaje_practico_diez = 10;
    }
}

async function crearCuestionario() {
    try {
        const response = await axios.post(`cuestionarios/`, nuevoCuestionario);
        emit('nuevo-cuestionario', { data: response.data.id });
        fetchCuestionario();
        uiStore.triggerSnackbar({
            message: t('Cuestionario') + ' ' + t('creado_con_éxito'),
            color: 'success',
        });
        openPreguntasDialog();
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            // Extract error messages from the response body
            const errors = error.response.data;
            let errorMessage = '';
            // Iterate over each key in the errors object to build the message
            Object.keys(errors).forEach((key) => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`; // Join to convert possible arrays into strings
            });
            snackbarText.value = errorMessage;
        } else {
            // If the error response is not in the expected format
            snackbarText.value = error;
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    }
    dialog.value = false;
}

async function exportarCuestionario(embedFiles = false) {
    try {
        const url = `cuestionarios/${props.IDcuestionario}/export/?embed_files=${embedFiles}`;
        const res = await axios.get(url, { responseType: 'blob' });
        const blob = new Blob([res.data], { type: 'application/json;charset=utf-8' });
        const href = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = href;
        a.download = `cuestionario-${props.IDcuestionario}${embedFiles ? '-con-imagenes' : ''}.json`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(href);
    } catch (e) {
        uiStore.triggerSnackbar({ message: e.message || e, color: 'error' });
    }
}

async function importarCuestionario(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('leccion_id', props.IDleccion);
        formData.append('modo', 'duplicar'); // o 'rehusar-si-existe'

        const res = await axios.post('cuestionarios/import/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        uiStore.triggerSnackbar({ message: t('Importado_con_éxito'), color: 'success' });

        // Si quieres abrir el recién importado:
        emit('nuevo-cuestionario', { data: res.data.id });
        // O refrescar la lista actual
        fetchCuestionario();

    } catch (e) {
        const msg = e.response?.data?.detail || e.message || e;
        uiStore.triggerSnackbar({ message: msg, color: 'error' });
    } finally {
        e.target.value = ''; // permite re-seleccionar el mismo archivo si hace falta
    }
}


function confirmarEliminacion() {
    if (
        confirm(
            '¿Estás seguro de que quieres eliminar este cuestionario? Esta acción no se puede deshacer.'
        )
    ) {
        eliminarCuestionario();
    }
}

async function eliminarCuestionario() {
    try {
        await axios.delete(`cuestionarios/${props.IDcuestionario}`);
        snackbarText.value = t('Cuestionario') + ' ' + t('eliminado_con_éxito');
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        emit('eliminar-cuestionario');
        closePreguntasDialog();
    } catch (error) {
        uiStore.triggerSnackbar({ message: error, color: 'error' });
    }
    dialog.value = false;
}

async function launchQuiz() {
    try {
        const response = await axios.post('/launch_quiz/', { quiz_id: props.IDcuestionario });
        if (response.data.session_code) {
            // Redirige al profesor a la ruta del panel docente
            router.push({ name: 'QuizzTeacher', params: { session_code: response.data.session_code } });
        }
    } catch (error) {
        console.error('Error launching quiz session:', error);
    }
}

onMounted(() => {
    if (props.selectedOptionVista == 'docente') {
        fetchAlumnes();
    }
});
</script>